<template>
  <div>
    <div class="content-container">
      <!-- 상단 페이지명, 스텝 -->
      <div class="top-wrap" flex fjb>
        <div class="step-title fs14 fw500">
          {{ $t("Verification.step4.foreignerKR.copyAuthId.title") }}
        </div>
        <div class="step-number" flex>
          <div class="number active">1</div>
          <div class="number active ml8">2</div>
          <div class="number active ml8">3</div>
          <div class="number active ml8">4</div>
        </div>
      </div>
      <!-- //상단 페이지명, 스텝 -->
      <!-- 상단 안내문구 -->
      <top-noti :topcontent="topcontent" class="mt20"></top-noti>
      <!-- //상단 안내문구 -->

      <!-- 이미지 업로드 -->
      <div>
        <div class="content-title mt12">
          <p class="fs14 fw500">
            {{ $t("Verification.step4.foreignerKR.copyAuthIdUpload") }}
          </p>
          <div class="mt8 fs12 graycolor">
            {{
              $t(
                "Verification.step4.foreignerKR.alienRegistrationCard.description",
              )
            }}
          </div>
          <div class="image-wrap mt24">
            <div class="text">
              {{
                $t(
                  "Verification.step4.foreignerKR.frontAlienRegistrationCard.title",
                )
              }}
              <!-- {{"외국인 등록증"}} <span class="sub-color">{{"앞면"}}</span> -->
            </div>

            <input
              type="file"
              name="idCardFront"
              ref="withIdFrontImg"
              style="display:none"
              @change="setFile"
            />
            <vs-button
              color="#dcdfe3"
              type="border"
              @click="$refs.withIdFrontImg.click()"
              class="foreigner-idcard-upload mt11"
            >
              <div class="img-box">
                <div v-if="imageUrl1" ref="imgPreview">
                  <img
                    :src="data.uploadImageFile1"
                    alt=""
                    :style="imgPreviewSize"
                  />
                </div>
                <div v-else>
                  <img
                    src="../../../../../../assets/img/mypage/Foreignercard_front.svg"
                    alt=""
                  />
                </div>
              </div>
            </vs-button>
          </div>
          <div class="image-wrap mt24">
            <div class="text">
              {{
                $t(
                  "Verification.step4.foreignerKR.backAlienRegistrationCard.title",
                )
              }}
              <!-- {{"외국인 등록증"}} <span class="sub-color">{{"뒷면"}}</span> -->
            </div>
            <input
              type="file"
              name="idCardEnd"
              ref="withIdEndImg"
              style="display:none"
              @change="setFile"
            />
            <vs-button
              color="#dcdfe3"
              type="border"
              @click="$refs.withIdEndImg.click()"
              class="foreigner-idcard-upload mt11"
            >
              <div class="img-box">
                <div v-if="imageUrl2" ref="imgPreview">
                  <img
                    :src="data.uploadImageFile2"
                    alt=""
                    :style="imgPreviewSize"
                  />
                </div>
                <div v-else>
                  <img
                    src="../../../../../../assets/img/mypage/Foreignercard_back.svg"
                    alt=""
                  />
                </div>
              </div>
            </vs-button>
          </div>
        </div>
      </div>
      <!-- //이미지 업로드 -->

      <!-- 알리슬라이드 -->
      <div class="recaptcha">
        <div class="allibaba">
          <allibaba
            @send-response-data-event="getResponseData"
            :swapvisible="false"
            ref="alibaba"
          ></allibaba>
        </div>
      </div>
      <!-- //알리슬라이드 -->

      <!-- 하단 안내 -->
      <div class="bottom-content mt24">
        <p class="fs14 fw500">
          {{ "신분증 제출" }}
        </p>
        <div class="gray-box mt8">
          <ul>
            <li class="list">
              {{
                $t(
                  "Verification.step4.foreignerKR.submitIdentification.description[0]",
                )
              }}
            </li>
            <li class="list">
              {{
                $t(
                  "Verification.step4.foreignerKR.submitIdentification.description[1]",
                )
              }}
            </li>
            <li class="list">
              {{
                $t(
                  "Verification.step4.foreignerKR.submitIdentification.description[2]",
                )
              }}
            </li>
            <li class="list">
              {{
                $t(
                  "Verification.step4.foreignerKR.submitIdentification.description[3]",
                )
              }}
            </li>
          </ul>
        </div>
      </div>
      <!-- //하단 안내 -->

      <!-- 다음 버튼 -->
      <div @click="submit" class="bottom-button-wrap bottom mt30" flex fjb>
        <button
          :disabled="
            imageUrl1 == false ||
              imageUrl2 == false ||
              data.ali_response.ali_token == undefined
          "
          class="next-button next"
        >
          {{ $t("Verification.common.next") }}
        </button>
      </div>
      <!-- //다음 버튼 -->
    </div>
  </div>
</template>

<script>
import topNoti from "../../authIdentity/top-noti.vue";
import allibaba from "../../../../../../components/login/allibaba.vue";

export default {
  components: {
    topNoti,
    allibaba,
  },
  props: {
    data: {
      uploadImageFile1: Object,
      uploadImageFile2: Object,
      idCardFront: Object,
      idCardEnd: Object,
      ali_response: Object,
      rcapt_id: String,
      files: {
        idCardFront: null,
        idCardEnd: null,
      },
    },
  },
  data() {
    return {
      topcontent: this.$t(
        "Verification.step4.foreignerKR.copyAuthId.description",
      ),
      imageUrl1: false,
      imageUrl2: false,
      imgPreviewSize: {
        width: "140px",
        height: "124px",
      },
      isAliUsing: true,
    };
  },
  methods: {
    setFile($event) {
      const { name, files } = $event.target;
      if (!files.length) {
        return false;
      }
      // size 체크
      const fileMaxSize = 10485760;
      if (
        files[0].size > fileMaxSize ||
        !/\.(jpg|jpeg|png)$/i.test(files[0].name)
      ) {
        this.$vs.notify({
          text: "You can upload Less than 10MB / Attach JPG image file only.",
          type: "warning",
          customClass: "dexko-noti",
          position: "top-left",
        });
        return false;
      }
      this.data.files[name] = files[0];

      if (name == "idCardFront") {
        // 앞면 업로드 시
        this.imageUrl1 = true; //이미지 미리보기 영역
        // 이미지 미리보기
        const reader = new FileReader();
        reader.onload = (e) => {
          this.data.uploadImageFile1 = e.target.result;
        };
        reader.readAsDataURL(files[0]);
      } else if (name == "idCardEnd") {
        // 뒷면 업로드 시
        this.imageUrl2 = true; //이미지 미리보기 영역
        // 이미지 미리보기
        const reader = new FileReader();
        reader.onload = (e) => {
          this.data.uploadImageFile2 = e.target.result;
        };
        reader.readAsDataURL(files[0]);
      }
    },
    // 취소
    residenceCancel() {
      this.data.files = {
        idCardFront: {},
        idCardEnd: {},
      };
    },
    // 알리슬라이드
    getResponseData(data) {
      if (!isNaN(data)) {
        this.data.rcapt_id = data;
        this.data.ali_response = null;
      } else {
        this.data.rcapt_id = null;
        this.data.ali_response = data;
      }
    },
    // 외국인 고객 정보 최종 api 호출
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
}
p {
  margin-bottom: 0;
}
.defaultColor {
  color: #333;
}
.sub-color {
  color: #00b473;
}
.keyColor {
  color: #eb3246;
}
.image-wrap {
  .img-box {
    position: relative;
    width: 140px;
    height: 140px;
    padding: 8px 0;
    // border: solid 1px #dcdfe3;
    border-radius: 6px;
    img {
      position: absolute;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      margin: 0 auto;
    }
  }
}
.bottom-content {
  .gray-box {
    padding: 14px 12px;
    border-radius: 4px;
    background-color: #f7f8fa;
    ul {
      li.list {
        position: relative;
        margin-top: 8px;
        padding-left: 10px;
        &:first-child {
          margin-top: 0;
        }
        &::before {
          content: "";
          position: absolute;
          top: 7px;
          left: 0;
          width: 4px;
          height: 4px;
          border-radius: 10px;
          background: #000;
        }
      }
    }
  }
}
// 하단 버튼
.bottom-button-wrap {
  width: 100%;
  button.next-button {
    width: 100%;
    padding: 10px 0;
    font-size: 12px;
    border-radius: 2px;
    border: 1px solid #00b473;
    background-color: #00b473;
    &:disabled {
      border: solid 1px #dadada !important;
      background-color: #dadada !important;
    }
  }
}

// step number
.step-number {
  .number {
    width: 20px;
    height: 20px;
    text-align: center;
    color: #dcdfe3;
    border-radius: 2px;
    background-color: #f7f8fa;
    &.active {
      color: #fff;
      background-color: #333;
    }
  }
}
</style>
